import React from 'react';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const DeleteButton = ({ onClick }) => {
  return (
    <IconButton
      onClick={onClick}
      size="medium"
      sx={{
        backgroundColor: 'red',
        color: 'white',
        '&:hover': {
          backgroundColor: 'darkred',
        },
        m: 2,
      }}
    >
      <DeleteIcon fontSize="medium" />
    </IconButton>
  );
};

export default DeleteButton;
